import { render, staticRenderFns } from "./ReviewsGrid.vue?vue&type=template&id=7a7baac6&scoped=true&"
import script from "./ReviewsGrid.vue?vue&type=script&lang=js&"
export * from "./ReviewsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7baac6",
  null
  
)

export default component.exports